import { fileUrl } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { Check, Wand2 } from "lucide-react";

const COVER_LABELS = { white: "Fundo branco", cover: "Capa vendável", metaads: "Criativo Meta Ads" };

export function MediaPanel({
  product, coverChoice, setCoverChoice,
  metaOpen, setMetaOpen, metaPrompt, setMetaPrompt, runMetaAds, metaLoading,
}) {
  const coverSrc = fileUrl(product.images?.[coverChoice] || product.images?.cover);
  const variants = ["white", "cover", "metaads"].filter((k) => product.images?.[k]);

  return (
    <div className="space-y-5">
      <div className="rounded-2xl bg-white border border-[#e8d8c8] overflow-hidden shadow-sm">
        <div className="aspect-square bg-[#fdf8f3]">
          {coverSrc && <img src={coverSrc} alt="capa" className="w-full h-full object-contain" data-testid="cover-preview" />}
        </div>
        <div className="p-4">
          <div className="text-xs font-semibold uppercase tracking-wider text-[#c17f3e] mb-2">Escolha a capa do anúncio</div>
          <div className="grid grid-cols-3 gap-2">
            {variants.map((k) => (
              <button
                key={k}
                onClick={() => setCoverChoice(k)}
                data-testid={`cover-option-${k}`}
                className={`relative rounded-xl overflow-hidden border-2 transition ${coverChoice === k ? "border-[#f0791f]" : "border-transparent hover:border-[#e8d8c8]"}`}
              >
                <img src={fileUrl(product.images[k])} alt={COVER_LABELS[k]} className="w-full aspect-square object-cover" />
                {coverChoice === k && <span className="absolute top-1 right-1 bg-[#f0791f] text-white rounded-full p-0.5"><Check size={12} /></span>}
                <span className="block text-[10px] py-1 text-[#5c4634] bg-white">{COVER_LABELS[k]}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="rounded-2xl bg-white border border-[#e8d8c8] p-4 shadow-sm">
        <div className="text-xs font-semibold uppercase tracking-wider text-[#c17f3e] mb-2">Vídeo de 15s pra Shopee</div>
        {product.video_url ? (
          <video src={fileUrl(product.video_url)} controls loop className="w-full rounded-xl bg-black" data-testid="product-video" />
        ) : (
          <p className="text-sm text-[#8c735f]">Vídeo indisponível.</p>
        )}
      </div>

      <Dialog open={metaOpen} onOpenChange={setMetaOpen}>
        <DialogTrigger asChild>
          <button className="w-full rounded-2xl border border-dashed border-[#c17f3e] bg-[#fff6ec] p-4 text-left hover:bg-[#ffefdd] transition flex items-center gap-3" data-testid="open-metaads-modal">
            <div className="w-11 h-11 rounded-xl bg-[#f0791f] text-white flex items-center justify-center"><Wand2 size={20} /></div>
            <div>
              <div className="font-semibold text-[#9c5f27]">Gerar criativo com <code className="text-[#f0791f]">/metaads</code></div>
              <div className="text-xs text-[#8c735f]">Imagem de anúncio pro Facebook e Instagram</div>
            </div>
          </button>
        </DialogTrigger>
        <DialogContent data-testid="meta-ads-generator-modal">
          <DialogHeader>
            <DialogTitle className="font-display text-[#9c5f27]">Criativo para Meta Ads</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-[#5c4634]">Digite <code className="text-[#f0791f]">/metaads</code> seguido de uma ideia opcional (ex.: fundo colorido, estilo minimalista).</p>
          <textarea
            value={metaPrompt}
            onChange={(e) => setMetaPrompt(e.target.value)}
            rows={3}
            data-testid="metaads-prompt-input"
            className="w-full rounded-xl border border-[#e8d8c8] px-4 py-3 text-sm outline-none focus:border-[#f0791f] focus:ring-2 focus:ring-[#f0791f]/20"
          />
          <button onClick={runMetaAds} disabled={metaLoading} className="btn-orange w-full py-3 rounded-full font-semibold flex items-center justify-center gap-2 disabled:opacity-60" data-testid="metaads-generate-btn">
            <Wand2 size={18} /> {metaLoading ? "Gerando..." : "Gerar criativo"}
          </button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
